import React from 'react';
import Translation from '../translation/translation';

function VoucherCodeLightBoxHeader() {
  return (
    <div className="cross-sell-remove-light-box__header cross-sell-remove-light-box-header">
      <Translation
        tagName="div"
        className="cross-sell-remove-light-box-header__headline"
        translationKey={'cart-voucher-header'}
      />
    </div>
  );
}

export { VoucherCodeLightBoxHeader };
